import A11yDialog from 'a11y-dialog';
import VimeoPlayer from '@vimeo/player';
import youtubePlayer from 'youtube-player';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const videoModal = (videoModalElement) => {
    // If videoModal doesn't exist, stop the script
    if (!videoModalElement) {
        return;
    }

    const videoModalWrapper = videoModalElement.querySelector('.video-modal-wrapper');
    const videoContainer = videoModalElement.querySelector('.video-player');
    const videoPlatform = videoModalElement.getAttribute('data-video-type');
    const videoId = videoModalElement.getAttribute('data-video-id');

    // If videoId doesn't exist, stop the script
    if (!videoId) {
        return;
    }

    let player;

    if (videoPlatform === 'vimeo') {
        player = new VimeoPlayer(videoContainer, {
            id: videoId,
            autoplay: false, // Set autoplay to false
            playsinline: true,
        });
    } else if (videoPlatform === 'youtube') {
        player = youtubePlayer(videoContainer, {
            videoId: videoId,
            playerVars: {
                autoplay: 0, // Set autoplay to 0
                playsinline: 1,
            },
        });
    }

    videoModalWrapper.appendChild(videoContainer);

    const dialog = new A11yDialog(videoModalElement);

    dialog.on('show', () => {
        disableBodyScroll(videoModalElement);

        if (videoPlatform === 'vimeo') {
            player.play();
        } else if (videoPlatform === 'youtube') {
            player.playVideo();
        }
    });

    dialog.on('hide', () => {
        enableBodyScroll(videoModalElement);
        if (videoPlatform === 'vimeo') {
            player.unload();
        } else if (videoPlatform === 'youtube') {
            player.stopVideo();
        }
    });
};

// Example usage
// const videoModalElement1 = document.getElementById('home-video-1');
// videoModal(videoModalElement1);

// const videoModalElement2 = document.getElementById('home-video-2');
// videoModal(videoModalElement2);

export default videoModal;
